import { inject } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot, CanActivateFn } from '@angular/router';
import { Account } from '@app/_models';

import { AccountService } from '@app/_services';

export const authGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    const router = inject(Router);
    const accountService = inject(AccountService);

    const account: Account = accountService.accountValue;
    if (account) {
        if (account.passwordExpired) {
            router.navigate(['/profile/change-password']);
            return false;
        }

        // check if route is restricted by role
        if (route.data.roles) {
            if (!route.data.roles.some(i => account.roles.includes(i))) {
                // role not authorized so redirect to home page
                router.navigate(['/']);
                return false;
            }

            if (route.data.hasOwnProperty('externalUrl')) {
                // Redirect is now handled by the LoadingAppComponent to allow for transition animations
                return true;
            }
        }

        // authorized so return true
        return true;
    }

    // not logged in so redirect to login page with the return url
    router.navigate(['/account/login'], { queryParams: { returnUrl: state.url } });
    return false;
};